<template>
  <section class="banners" v-if="page.ItemID">
    <div class="cycle-slideshow" v-if="page.ItemID == $store.state.homeID">
      <div :key="banner._id" class="slide" v-for="banner in page.banners">
        <imgix :alt="banner.caption" :h="733" :src="banner.image" :w="1903"/>
      </div>
      <div class="caption">
        <span>
          <span class="intro1">{{page.intro_1}}</span>
          <br>
          <span class="intro2">{{page.intro_2}}</span>
          <br>
          <a class="down" href="#content">
            <i aria-label="Scroll down" class="fa fa-angle-down bounce"></i>
          </a>
        </span>
      </div>
    </div>
    <div class="cycle-slideshow" v-else>
      <div :key="banner._id" class="slide" v-for="banner in page.banners">
        <img :alt="banner.caption" :src="banner.image">
        <div class="caption-inner">{{banner.caption}}</div>
      </div>
    </div>
  </section>
</template>

<script>
import api from "@/services/api"

export default {
  name: "PageBanners",
  props: ["page"],
  created: function() {},
  methods: {
    getAboutBanners: function() {
      api.getPageByItemID(this.$store.state.aboutID, "banners").then(about => this.setBanners(about.banners))
    },
    setBanners: function(banners) {
      this.$set(this.page, "banners", banners)
      this.initCycle()
    },
    initCycle: function() {
      this.$nextTick().then(() => {
        window.$(".cycle-slideshow").cycle({ slides: ".slide" })
      })
    }
  },
  watch: {
    page: function() {
      // if page object has ItemID (if loaded)
      // if not home page or about page (nowhere to inherit banners from)
      // if no banners object or banners has no length
      // then get banners from parent or about
      if (this.page.ItemID && this.page.ItemID !== this.$store.state.homeID && this.page.ItemID !== this.$store.state.aboutID && (!this.page.banners || !this.page.banners.length)) {
        if (this.page.ParentID) {
          api.getPageByItemID(this.page.ParentID, "banners").then(parent => {
            if (parent.banners && parent.banners.length) this.setBanners(parent.banners)
            else this.getAboutBanners()
          })
        } else {
          this.getAboutBanners()
        }
      } else if (this.page.ItemID) this.initCycle()
    }
  }
}
</script>

<style scoped>
.banners {
  position: relative;
  z-index: 1;
  line-height: 0;
}
.banners img {
  opacity: 1;
}
.slide {
  position: relative;
}
.caption {
  position: absolute;
  top: 0;
  height: 100%;
  text-align: center;
  width: 100%;
  font-family: "Roboto Slab", Georgia, "Times New Roman", Times, serif;
  font-size: 3rem;
  line-height: 1.5;
  z-index: 200;
}
.caption > span {
  position: relative;
  top: 38%;
  color: white;
}

.caption-inner {
  font-family: "Roboto Slab", Georgia, "Times New Roman", Times, serif;
  font-size: 2.5rem;
  background: #8fa1a1;
  padding: 1.5rem 1.5rem;
  position: absolute;
  bottom: 4rem;
  right: 4rem;
  line-height: 1;
  color: white;
}

.intro1 {
  font-size: 5rem;
  background: #8fa1a1;
  padding: 0 2rem;
  bottom: -0.3rem;
  position: relative;
}

.intro2 {
  font-size: 3.5rem;
  background: #afb827;
  padding: 0.5rem 1.5rem;
}

.down {
  font-size: 7rem;
}

@media screen and (max-width: 1150px) {
  .caption > span {
    top: 28%;
  }
}

@media screen and (max-width: 950px) {
  .down {
    display: none;
  }

  .caption {
    text-align: left;
  }

  .caption > span {
    bottom: 2rem;
    top: auto;
    position: absolute;
    padding: 1rem 2rem;
  }

  .intro1 {
    font-size: 3.5rem;
    padding: 0 2rem;
    bottom: -0.7rem;
  }

  .intro2 {
    font-size: 2.5rem;
    padding: 0.5rem 1.5rem;
  }
}

@media screen and (max-width: 650px) {
  .intro1 {
    font-size: 2.5rem;
    bottom: -1.8rem;
  }

  .intro2 {
    font-size: 1.5rem;
  }

  .caption-inner {
    display: none;
  }

  .banners {
    overflow: hidden;
  }

  .banners img {
    width: 150%;
    max-width: 150%;
    position: relative;
    left: -25% !important;
  }

  .intro2 {
    display: inline-block;
    padding: 0.5rem 1rem;
    margin-top: 1.3rem;
  }

  .caption > span {
    bottom: 1rem;
  }
}
</style>
